import { business } from "@/lib/business";

const SHARE_IMAGE =
  "https://pub-bb2e103a32db4e198524a2e9ed8f35b4.r2.dev/2c39288f-c1c3-445f-9081-bd8ff15549ac/id-preview-318aff03--cbf64eef-ab48-496d-aaa9-e5fb7993badc.lovable.app-1785779976762.png";

type PageSeoInput = {
  title: string;
  description: string;
  path: string;
};

export function pageHead({ title, description, path }: PageSeoInput) {
  const url = `${business.siteUrl}${path}`;

  return {
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: url },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
      { property: "og:image", content: SHARE_IMAGE },
      { name: "twitter:image", content: SHARE_IMAGE },
      { name: "geo.region", content: "US-AL" },
      { name: "geo.placename", content: "Enterprise, Alabama" },
    ],
    links: [{ rel: "canonical", href: url }],
  };
}

export function localBusinessJsonLd(description: string) {
  return {
    "@context": "https://schema.org",
    "@type": "AutoMachineShop",
    name: business.name,
    description,
    telephone: business.phone,
    email: business.email,
    url: business.siteUrl,
    foundingDate: "2016-01-01",
    address: {
      "@type": "PostalAddress",
      streetAddress: business.address,
      addressLocality: business.city,
      addressRegion: business.state,
      postalCode: business.zip,
      addressCountry: "US",
    },
    image: `${business.siteUrl}/images/hero-engine-1024.jpg`,
    logo: `${business.siteUrl}/images/champion-logo-240.png`,
    areaServed: business.areaServed,
    geo: {
      "@type": "GeoCoordinates",
      latitude: business.latitude,
      longitude: business.longitude,
    },
    hasMap: business.mapsUrl,
    sameAs: [business.googleReviewsUrl],
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "08:00",
        closes: "12:00",
      },
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "13:00",
        closes: "17:00",
      },
    ],
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+1-334-393-5401",
      contactType: "customer service",
      areaServed: "US",
      availableLanguage: "English",
      hoursAvailable: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "08:00",
        closes: "17:00",
      },
    },
    potentialAction: {
      "@type": "CommunicateAction",
      name: "Call the shop",
      target: {
        "@type": "EntryPoint",
        urlTemplate: business.phoneHref,
        actionPlatform: [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform",
        ],
      },
    },
    makesOffer: [
      "Cylinder boring",
      "Cylinder sleeving",
      "Stroker block machining",
      "Line boring and honing",
      "Cylinder honing",
      "Engine block and head surfacing",
      "Seat and valve guide machining",
      "Rotating assembly balancing",
      "Lathe work",
      "Magnaflux crack detection",
      "Diesel engine machining",
    ].map((name) => ({ "@type": "Offer", itemOffered: { "@type": "Service", name } })),
  };
}
